module.exports = __webpack_public_path__ + "static/img/retail4.d1b4141.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/retail4.png
// module id = SZ+/
// module chunks = 2